<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <!-- zona de filtros -->
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i>{{'General.filters' | translate}}</span>
          </p-header>
          <div class="row">
            <div class="col-12">
              <formElement [model]="filters" name="from" [fieldConfig]="getFieldConfig(this.FROM_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="to" [fieldConfig]="getFieldConfig(this.TO_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="user" [fieldConfig]="getFieldConfig(this.USER_PARAM)" #ref>
              </formElement>
            </div>
            <div class="col-12">
              <button class="btn btn-primary" (click)="search()" type="button">{{'General.search.text' |
                translate}}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <!-- zona de datos -->
        <p-panel>
          <p-header>
            <!-- <span>
         <i class="fa fa-file" aria-hidden="true"></i> Auditoria</span> -->
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{ audits ? audits.length : '0' }}</span>
          </p-header>
          <p-table [value]="audits" sortField="date" sortOrder="1" [paginator]="false" class="footer-over-pagination">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="6"> No se han encontrado logs </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="date" styleClass="col-2 text-right">Fecha <p-sortIcon field="date"></p-sortIcon>
                </th>
                <th pSortableColumn="type" styleClass="col-2">Tipo <p-sortIcon field="type"></p-sortIcon>
                </th>
                <th pSortableColumn="operation" styleClass="col-2">Operación <p-sortIcon field="operation"></p-sortIcon>
                </th>
                <th pSortableColumn="user" styleClass="col-2">Usuario <p-sortIcon field="user"></p-sortIcon>
                </th>
                <th pSortableColumn="success" styleClass="col-1 text-center">Resultado <p-sortIcon field="success">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="operationTime" styleClass="col-2 text-right">Tiempo (ms) <p-sortIcon
                    field="operationTime"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
              <tr>
                <td>{{event.date | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{event.type}}</td>
                <td>{{event.operation}}</td>
                <td>
                  <span *ngIf="event.user"> {{ event.user?.identifier }} </span>
                </td>
                <td>
                  <span *ngIf="event.success">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </span>
                  <span *ngIf="!event.success">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  </span>
                </td>
                <td> {{ event.operationTime | number }} </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>